export default "__VITE_ASSET__BJ$B30Kh__"